var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"rel":"nofollow noopener noreferrer","target":"_blank","href":_vm.value}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }